export const checkIfNotDefault = (value: string): boolean => (value !== "disabled")

export const checkIfTicked = (value: boolean): boolean => (value)